import { render, staticRenderFns } from "./TissueSelectPicker.vue?vue&type=template&id=1147c4df&"
import script from "./TissueSelectPicker.vue?vue&type=script&lang=js&"
export * from "./TissueSelectPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1147c4df')) {
      api.createRecord('1147c4df', component.options)
    } else {
      api.reload('1147c4df', component.options)
    }
    module.hot.accept("./TissueSelectPicker.vue?vue&type=template&id=1147c4df&", function () {
      api.rerender('1147c4df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TissueSelectPicker.vue"
export default component.exports